<template>
    <div style="position: relative;">
        <div id="graph" class="" style="height: 600px;"></div>
        <v-menu 
            v-model="showMenu"
            :close-on-content-click="false"
            :nudge-width="200"
            :position-x="offsetX"
            :position-y="offsetY"
            absolute
        >
            <v-list>
                <v-list-item
                v-for="(item, index) in menus"
                :key="index"
                @click="checkItem(item,index)"
                :disabled="item.disbled"
        
                >
                <v-list-item-title>{{ item.name }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <v-dialog v-model="dialog" :overlay="false" max-width="500px" transition="dialog-transition">
            <v-card>
                <div class="d-flex align-end mb-3">
                    <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
                        <v-icon color="white"> mdi-bookmark </v-icon>
                    </v-card>
                    <span class="h4 ml-1 mb-n1">节点信息</span>
                </div>
                <!-- <div class="px-6 pt-3">
                    <v-select v-model="form.mode" :items="[
                        { name: '教学活动', value: 'topic' },
                        { name: '任务', value: 'task' },
                    ]
                        " label="节点类型" required item-text="name" item-value="value"></v-select>
                </div> -->
                <!-- 教学活动表单 -->
                <v-form v-if="form.mode === 'topic'" v-model="valid" ref="form" class="px-6 pb-3">
                    <v-text-field v-model="form.name" label="教学活动名称" required :rules="rules['taskName']"> </v-text-field>
                    <v-textarea class="mt-2" v-model="form.description" label="描述" auto-grow clearable></v-textarea>
                </v-form>
                <!-- 任务信息表单 -->
                <v-form v-else v-model="valid" ref="form" class="px-6 py-3">
                    <v-text-field v-model="form.name" label="任务名称" required :rules="rules['taskName']"> </v-text-field>
                    <v-select v-model="form.taskEditor" :items="sceneList" label="任务场景" no-data-text="暂未创建任务场景" required
                    :rules="rules['taskMode']" item-text="name" item-value="_id"></v-select>
                    <v-select v-model="form.cognitionType" :items="taskCognitionList" label="认知" required
                    :rules="rules['cognitionType']" item-text="name" item-value="value"></v-select>
                    <v-select v-model="form.knowlegeType" :items="taskKnowlegeList" label="性质" required
                    :rules="rules['knowlegeType']" item-text="name" item-value="value"></v-select>
                    <v-textarea class="mt-2" v-model="form.description" label="任务描述" auto-grow clearable></v-textarea>
                </v-form>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click.stop="confirm">提交</v-btn>
                    <v-btn color="gray" @click.stop="dialog = false">取消</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-snackbar
      v-model="snackbar"
      :timeout="1000"
      top
      centered
      color="warning"
      outlined
      
    >
      {{ text }}
    </v-snackbar>

        <TaskInfo />
    </div>
</template>
<script>
import TaskInfo from './Main/Action/TaskInfo.vue'
import { initGraph, addChildNode, removeNode, graphRender, numbericWidth, findItem } from './CouseGraphOption';
import { mapGetters } from 'vuex';
import { deleteTask } from '@/api/task/task'
let graph;

export default {
    computed: {
        ...mapGetters(['project', 'sceneList', 'taskList'])
    },
    components: {
        TaskInfo,
    },
    watch: {
        taskList() {
            this.initData();
            this.render()
        }
    },
    data() {
        return {
            snackbar:false,
            text:"正在完善!",
            dialog: false,
            showMenu: false,
            graphData: {},
            nodeDict: {},
            offsetX: 0,
            offsetY: 0,
            rules: {
                name: [(v) => !!v || '请填写任务名称'],
                taskMode: [(v) => !!v || '请选择任务模式'],
                taskEditor: [(v) => !!v || '请选择任务场景']
            },
            form: {
                mode: 'topic'
            },
            valid: false,
            curNodeId: 1,
            checkedEdgeId: -1,
            taskCognitionList: [
                { value: 'memory', name: '记忆' },
                { value: 'understand', name: '理解' },
                { value: 'apply', name: '应用' },
                { value: 'analyze', name: '分析' },
                { value: 'appraise', name: '评价' },
                { value: 'create', name: '创造' },
            ],
            taskKnowlegeList: [
                { value: 'fact', name: '事实性知识' },
                { value: 'concept', name: '概念性知识' },
                { value: 'program', name: '程序性知识' },
                { value: 'meta', name: '元认知' },
            ],
            menus: [
                  { name: '添加任务节点', cmd: 'addTask',disbled:false }
                , { name: '添加教学活动', cmd: 'addTopic',disbled:false }
                , { name: '编辑', cmd: 'edit',disbled:false  }
                , { name: '复制', cmd: 'copy' ,disbled:false }
                , { name: '删除', cmd: 'removeNode',disbled:false  }
            ],
            disabledMenu:false,
            rightMenuData:{},
            rightMenuType:{},
            rightNode:null,

        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initData();
            this.initGraph()
        })
        console.log('process.env.VUE_APP_TASK_FLOW_URL :>> ', process.env.VUE_APP_TASK_FLOW_URL);

    },
    methods: {
        initData() {
            let project = this.project;
            if (Object.keys(project).length === 0) {
                this.graphData = {};
                return;
            };
            if (project.projectGraphData === undefined) {
                let root = {
                    id: project._id,
                    type: 'root',
                    label: project.name ?? '未命名节点',
                    width: numbericWidth(project.name),
                    height: 50,
                    appendData: project,
                };
                this.nodeDict[root.id] = root;

                root.children = this.taskList.map(task => {
                    let data = {
                        id: task._id,
                        type: 'task',
                        label: task.name,
                        width: numbericWidth(task.name),
                        height: 50,
                        children: [],
                        appendData: task,
                    };
                    this.nodeDict[task._id] = data;
                    return data;
                })

                this.graphData = root;
                return;
            }
            this.graphData = project.projectGraphData
        },
        initGraph() {
            let dom = document.getElementById('graph');
            graph = initGraph(dom);
            graph.on('add:topic', ({ node }) => {
                this.dialog = true;
                const { id } = node
                this.curNodeId = id;
                this.form = {}
                this.form.mode = 'task'
            })

            graph.on("edge:click", ({ edge }) => {
                this.checkedEdgeId = edge.id;
            });


            graph.bindKey(['backspace', 'delete'], (node) => {
                if (this.checkedEdgeId !== -1) {
                    graph.removeEdge(this.checkedEdgeId);
                    this.checkedEdgeId = -1;
                }
                const selectedNodes = graph
                    .getSelectedCells()
                    .filter((item) => item.isNode())
                if (selectedNodes.length) {
                    const { id } = selectedNodes[0]
                    if (removeNode(this.graphData, id)) {
                        this.render()
                        this.saveProjectGraph()
                        if(selectedNodes[0]&&selectedNodes[0].shape=="task"){
                          deleteTask({id:id}).then(res=>{ })
                        }
                      
                    }
                 
                }
            })

            graph.bindKey('tab', (e) => {
                e.preventDefault()
                const selectedNodes = graph.getSelectedCells().filter((item) => item.isNode())
                if (selectedNodes.length) {
                    const node = selectedNodes[0]
                    const type = node.prop('type')
                    if (type === 'task') return;
                    const childNode = addChildNode(this.graphData, {
                        curId: node.id,
                        type: 'topic',
                        label: '未命名节点',
                        appendData: {
                            name: '未命名节点',
                            mode: 'topic'
                        },
                    });
                    this.render();
                    graph.centerCell(graph.getCellById(childNode.id));
                    this.saveProjectGraph();
                }
            })

            graph.on('edge:connected', ({ edge, view }) => {
                const { sourceView, targetView } = view;
                if (sourceView.cell.shape === 'task' && targetView.cell.shape === 'task') {
                    graph.removeEdge(edge.id)
                } else {
                    this.saveProjectGraph()
                }
            })

            this.render()
            graph.centerContent();

            graph.on('node:dblclick', (e) => {
                let { node } = e;
                let data = findItem(this.graphData, node.id)
                if (data.node.type === 'task') {
                    this.$store.dispatch("task/setTaskInfo", Object.assign({}, data.node.appendData));
                    this.$store.dispatch("editorDefinition/loadData", data.node.appendData.taskEditor);
                    this.$store.dispatch("editorType/loadData", data.node.appendData.project);
                    this.$router.push({
                        path: "/taskFlow/" + data.node.id,
                    });
                    let obj =   {
                      path: "/design",
                      switchFlag:false
                    }
                    window.localStorage.setItem('switchFlag',JSON.stringify(obj))
                    
                    // let url = `${process.env.VUE_APP_TASK_FLOW_URL}/#/${data.node.id}?token=${localStorage.getItem('token')}`
                    // window.open(url, '_blank')
                }
            })
            graph.on('blank:contextmenu', (e) => {
                console.log('e :>> ', e);
                this.showMenu = false;
            })
            graph.on('node:contextmenu', (event) => {
                this.showMenu = true;
                let { node, e } = event;
                const { pageX, pageY } = e;
                this.offsetX = pageX;
                this.offsetY = pageY;
                let data = findItem(this.graphData, node.id)
                this.rightMenuData = graph.getNeighbors(node,{incoming:true})
                this.rightMenuType = data
                this.rightNode = event
                console.log(data.node.type)
                this.isActiveDisabled(data);
    
            })

        },

        isActiveDisabled(data){
          if (data.node.type === 'root'){
                    this.disabledMenu = true
                    this.menus.forEach(item=>{
                      switch(item.cmd){
                        case 'addTask':
                        this.$set(item,"disbled",false)
                        break;

                        case 'addTopic':
                        this.$set(item,"disbled",false)
                        break;

                        case 'edit':
                          this.$set(item,"disbled",true)
                        break;

                        case 'copy':
                        this.$set(item,"disbled",true)
                        break;

                        case 'removeNode':
                        this.$set(item,"disbled",true)
                        break;
                      }
                     
                    })
                    return 
                }

                if (data.node.type === 'topic'){
                    this.menus.forEach(item=>{
                          this.$set(item,'disbled',false)
                    })
                }

                if(data.node.type === 'task'){
                  this.menus.forEach(item=>{
                      switch(item.cmd){
                        case 'addTask':
                        this.$set(item,"disbled",true)
                        break;

                        case 'addTopic':
                        this.$set(item,"disbled",true)
                        break;

                        case 'edit':
                        this.$set(item,"disbled",false)
                        break;

                        case 'copy':
                        this.$set(item,"disbled",false)
                        break;

                        case 'removeNode':
                        this.$set(item,"disbled",false)
                        break;
                      }
                     
                    })
                }
       
                  this.disabledMenu = false
                  this.form.mode = data.node.type
                  this.form = data.node.appendData;
                  return 

               

        },
   
        //右键编辑选中菜单
        async checkItem(data,index){

          console.log(this.disabledMenu,'=====')
          if(data.cmd=='edit'&&this.disabledMenu==false){
             this.dialog = true;
           }else if(data.cmd=='removeNode'&&this.disabledMenu==false){  //删除
              if (this.checkedEdgeId !== -1) {
                    graph.removeEdge(this.checkedEdgeId);
                    this.checkedEdgeId = -1;
              }
              //判断删除项目是任务节点还是任务节点的父节点
                if (this.form.hasOwnProperty('_id')){ 
                      deleteTask({id:this.form._id}).then(res=>{ })
                    if (removeNode(this.graphData, this.form._id)) {
                          this.render()
                          this.saveProjectGraph()
                          this.showMenu = false;
                    }
                    return 
                }

                const selectedNodes = graph
              .getSelectedCells()
              .filter((item) => item.isNode())
                if(selectedNodes.length<=0){
                  this.$store.dispatch("global/showWarningMsg",'请选中删除项')
                  return 
                }

                if (selectedNodes.length) {
                  const { id } = selectedNodes[0]
                  if (removeNode(this.graphData, id)) {
                      this.render()
                      this.saveProjectGraph()
                      this.showMenu = false;
                  }
                }
            
           }else if(data.cmd=='addTopic'){
               this.addTeachingActivity()
           }else if(data.cmd=='addTask'){
            if( !this.rightNode)return 
            let {node,e} = this.rightNode;
            this.dialog = true;
            this.curNodeId = node.id;
            this.form = {}
            this.form.mode = 'task'

           }else if(data.cmd=='copy'){
             
            const selectedNodes = graph.getSelectedCells().filter((item) => item.isNode())
                if(selectedNodes.length<=0){
                      this.$store.dispatch("global/showWarningMsg",'请选中')
                      return 
               }

              if(this.rightMenuType&&this.rightMenuType.parent){ //针对于当前选中的是教学任务,父节点是根节点情况
                  if(this.rightMenuType.parent.type=="root"&&this.rightMenuType.node.type=='topic'){
                      const selectedNodes = graph.getSelectedCells().filter((item) => item.isNode())
                      if (selectedNodes.length) {
                      const node = selectedNodes[0]
                      const type = node.prop('type')
                      if (type === 'task') return;
                      const childNode = addChildNode(this.graphData, {
                          curId: this.rightMenuType.parent.id,
                          type: 'topic',
                          label: '未命名节点',
                          appendData: {
                          name: '未命名节点',
                          mode: 'topic'
                      },
                      });
                      this.render();
                      graph.centerCell(graph.getCellById(childNode.id));
                      this.saveProjectGraph();
                      return 
                      }
                      return 
                  }
                  if(this.rightMenuType.parent.type=="topic"){
                      if(this.rightMenuType.node.type=='topic'){
                          this.addTeachingActivity('topic')
                          return 
                      }
                  }
              }
              //添加任务节点
              if(this.rightMenuType&&this.rightMenuType.node){  
                  let thisDatas = this.rightMenuType.node;
                  let forms = {
                    cognitionType:thisDatas.appendData.cognitionType,
                    description:thisDatas.appendData.description,
                    knowlegeType:thisDatas.appendData.knowlegeType,
                    mode:thisDatas.type,
                    name:thisDatas.label+'copy',
                    taskEditor:thisDatas.appendData.taskEditor
                  }
                  let  res = await this.$store.dispatch('task/saveTask',forms)
                  if(res){
                    let node = addChildNode(this.graphData, {
                        curId: this.rightMenuData[0].id,
                        id: res.data._id,
                        type: thisDatas.type,
                        label: forms.name,
                        appendData: res.data,
                    })
                    this.render();
                    graph.centerCell(graph.getCellById(node.id));
                    // this.clearForm();
                    this.saveProjectGraph()
                  }

              }

 
           }else{
            this.snackbar = true
          }
        },

        //添加教学活动
        addTeachingActivity(type=''){
        if(type==''){
          const selectedNodes = graph.getSelectedCells().filter((item) => item.isNode())
          if(selectedNodes.length<=0){
              this.$store.dispatch("global/showWarningMsg",'请选中')
              return 
            }
                if (selectedNodes.length) {
                    const node = selectedNodes[0]
                    const type = node.prop('type')
                    if (type === 'task') return;
                    const childNode = addChildNode(this.graphData, {
                        curId: node.id,
                        type: 'topic',
                        label: '未命名节点',
                        appendData: {
                            name: '未命名节点',
                            mode: 'topic'
                        },
                    });
                    this.render();
                    graph.centerCell(graph.getCellById(childNode.id));
                    this.saveProjectGraph();
                }
                return 
           }

             const selectedNodes = graph.getSelectedCells().filter((item) => item.isNode())
                if (selectedNodes.length) {
                    const node = selectedNodes[0]
                    const type = node.prop('type')
                    if (type === 'task') return;
                    const childNode = addChildNode(this.graphData, {
                        curId: this.rightMenuType.parent.id,
                        type: 'topic',
                        label: '未命名节点',
                        appendData: {
                            name: '未命名节点',
                            mode: 'topic'
                        },
                    });
                    this.render();
                    graph.centerCell(graph.getCellById(childNode.id));
                    this.saveProjectGraph();

          }
        },
        render() {
            graphRender(this.graphData, graph);
        },
        async confirm() {
            let res;
            if (this.form.mode === 'task') {
                if (!this.form.taskEditor) {
                    this.$store.dispatch('global/showWarningMsg', '请选择任务场景');
                    return;
                }
                this.$refs.form.validate()
                if (this.valid) {
                    res = await this.$store.dispatch('task/saveTask', this.form)
                }
            }
            let node;
            let id = this.form.id ?? this.form._id;
            if (id) {
                let findData = findItem(this.graphData, id)
                node = findData.node;
                node.label = this.form.name;
                node.appendData = Object.assign({}, this.form);
            } else {
                node = addChildNode(this.graphData, {
                    curId: this.curNodeId,
                    id: res.data._id,
                    type: this.form.mode,
                    label: this.form.name,
                    appendData: res.data,
                })
            }

            this.render();
            graph.centerCell(graph.getCellById(node.id));
            this.clearForm();
            this.saveProjectGraph()
        },
        clearForm() {
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
            this.dialog = false;
            this.form = {}
            this.form.mode = 'topic'
        },
        saveProjectGraph() {
            let project = Object.assign({}, this.project);
            console.log('this.getTaskTree() :>> ', this.getTaskTree());
            project.projectGraphData = this.getTaskTree();
            project.projectGraphJsonData = graph.toJSON();
            this.$store.dispatch("courseAndProject/saveProject", project);
        },
        getTaskTree() {
            const graphMap = graph
                .getCells()
                .map(item => item.toJSON())
                .filter(item => item.shape === 'mindmap-edge')
                .reduce((pre, next) => {
                    if (pre[next.source.cell]) {
                        pre[next.source.cell].push(next.target.cell)
                        return pre;
                    }
                    pre[next.source.cell] = [next.target.cell]
                    return pre;
                }, {})

            const buildTree = (node) => {
                let childArr = graphMap[node.id] ?? []
                node.children = childArr.map(nodeId => {
                    const findData = findItem(this.graphData, nodeId)
                    const {
                        id, type, label, width
                        , height, appendData
                    } = findData.node;
                    let arr = [];
                    if (graphMap[id]) {
                        arr = graphMap[id].map(childId => {
                            const childData = findItem(this.graphData, childId);
                            return buildTree(childData.node)
                        });
                    }
                    return {
                        id, type, label, width
                        , height, appendData
                        , children: arr
                    }
                })
                return node;
            }

            return buildTree(this.graphData);
        },
    }
}
</script>
<style>
.topic-image {
    visibility: hidden;
    cursor: pointer;
}

.x6-node:hover .topic-image {
    visibility: visible;
}

.x6-node-selected rect {
    stroke-width: 2px;
}
</style>